import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { pageData } from "./pageData";

const SitePage = () => {
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params.page_id]);

  const data = pageData[params.page_id];


  return (
    <div key={data.id} className="px-8 sm:px-64 pt-4 sm:pt-12">
      <h1 className="text-3xl font-bold mb-12">{data?.heading}</h1>

      {data?.audioSrcArr && (
        <div className="flex justify-center mb-16">
          <div className="flex flex-col items-center gap-4">
            <div className="font-bold">Demo Call</div>

            {data?.audioSrcArr &&
              data?.audioSrcArr.map((audioSrc) => (
                <audio
                  className="border-2 border-black rounded-full shadow-md"
                  controls>
                  <source src={audioSrc} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              ))}
          </div>
        </div>
      )}

      {data.sections?.map((section, index) => {
        return (
          <div key={section.heading + index}>
            <h2 className="text-xl mt-10 mb-3 font-semibold">
              {section.heading}
            </h2>
            {section.content.map((para, index) => {
              return (
                <p
                  key={para}
                  className={`mt-4 ${
                    index + 1 === data.sections.length && "italic"
                  }`}>
                  {para}
                </p>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default SitePage;
